import { useEffect } from 'react'
import { groupBy } from 'ramda'

import { useDishesData } from 'app/dataProviders/dishes/DishesData'
import { SaleType } from 'app/dataTypes/dishes/saleType'
import { SkeletonLoading } from 'app/common/templates-next/page-template'


export type OccupiedSaleTypes = Array<[SaleType, Array<string> | null]>

type Props = {
  saleTypesToBeRemoved: Array<SaleType>
  onOccupiedSaleTypes: (occupiedSaleTypes: OccupiedSaleTypes) => void
  onDeletionAllowed: (allowed: boolean) => void
}

export const DeletionPossibilityCheck = ({
  saleTypesToBeRemoved,
  onOccupiedSaleTypes,
  onDeletionAllowed,
}: Props) => {
  const [{ dishes, loading }] = useDishesData()

  useEffect(() => {
    if (!loading) {
      if (dishes.length) {
        const bySaleType = groupBy(({ saleType: { id } }) => (id), dishes)
        onOccupiedSaleTypes(saleTypesToBeRemoved.map(saleType => ([
          saleType,
          bySaleType[saleType.id]?.map(({ title }) => title) || null,
        ])))
        onDeletionAllowed(false)
        return
      }
      onOccupiedSaleTypes([])
      onDeletionAllowed(true)
    }
  }, [dishes, loading]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!loading) return null

  return (
    <SkeletonLoading />
  )
}
